import PersonPicker from '@UI/personPicker/PersonPicker';
import type { PersonHref } from '@generalTypes/apiTypes';
import type { IApiResouce } from '@generalTypes/sriTypes';
import type { EditAsideContactsOrCreators } from '@nodeTypeConfig/configTypes';
import { patchNodeAction } from '@store/actions/documentActions';
import { getResourceKey } from '@store/helpers/documentHelpers';
import { set } from 'lodash';
import { any } from 'prop-types';
import type React from 'react';
import { useDispatch } from 'react-redux';
import { useEditHref } from '../../../hooks/UseEditHref';
import { useInitialValue } from '../../../hooks/UseInitialValue';

const AsidePersonPicker: React.FC<{
  config: EditAsideContactsOrCreators;
  readonly: boolean;
}> = ({ config, readonly }) => {
  const dispatch = useDispatch();
  const editHref = useEditHref();

  const currentValue: PersonHref[] | undefined = useInitialValue(config.property);

  const handleChange = (contactList: Array<IApiResouce> | IApiResouce) => {
    let contacts: string[] = [];
    if (Array.isArray(contactList)) {
      contacts = contactList.map((c) => c.$$meta.permalink);
    } else if (contactList) {
      contacts = [contactList.$$meta.permalink];
    }

    dispatch(patchNodeAction(getResourceKey(editHref), set({}, config.property, contacts)));
  };

  return (
    <PersonPicker
      config={config}
      readonly={readonly}
      onChange={handleChange}
      initialValue={currentValue}
    />
  );
};

export default AsidePersonPicker;

AsidePersonPicker.displayName = 'AsidePersonPicker';

AsidePersonPicker.propTypes = {
  config: any,
  readonly: any,
};
